import React, { useState } from 'react';
import NewsPart1 from '../components/news/newsPart1';
import NewsDetails from '../components/news/newsdetail';
import EzBottom from '../components/bottom'
import { NewsCustomDataProvider } from './context/newsCustomDataProvider';
import "../assets/css/news.css"

const News: React.FC = () => {
    const [currentView, setCurrentView] = useState('mainLogin');
    const [viewData, setViewData] = useState(null);

    const renderView = () => {
        switch (currentView) {
            case 'news':
                return <NewsPart1 handleViewChange={handleViewChange} data={viewData} />;
            case 'newsdetails':
                return <NewsDetails handleViewChange={handleViewChange} data={viewData} />;
            default:
                return <NewsPart1 handleViewChange={handleViewChange} data={viewData} />;
        }
    };

    const handleViewChange = (newView: string, data?: any) => {
        setCurrentView(newView);
        setViewData(data);
    };

    return (
        <NewsCustomDataProvider>
            <div className='News'>
                {renderView()}
                <EzBottom></EzBottom>
            </div>
        </NewsCustomDataProvider>
    )

};

export default News;
